// src/pages/common-components/TestDrive/TestDrive.tsx
// A first-class "Book a Test Drive" entry point, reachable directly from the
// header/homepage without first having to pick a specific car. Previously
// the homepage advertised "Book a Test Drive Today" as marketing copy with
// no real link behind it — see answers.text.
import React from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import BackToTop from '../Back-to-top/BackToTop';
import HeaderSpacer from '../Header/HeaderSpacer';
import ReserveCarModal from '../Reservation/ReserveCarModal';

const TestDrive: React.FC = () => {
  return (
    <div>
      <Header />
      <HeaderSpacer />

      <div className="container">
        <div className="bread-crumb flex-w p-l-25 p-r-15 p-t-30 p-lr-0-lg">
          <a href="/" className="stext-109 cl8 hov-cl1 trans-04">
            Home
            <i className="fa fa-angle-right m-l-9 m-r-10" aria-hidden="true"></i>
          </a>
          <span className="stext-109 cl4">Book a Test Drive</span>
        </div>
      </div>

      <section className="bg0 p-t-30 p-b-85" style={{ minHeight: '50vh' }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7">
              <ReserveCarModal
                defaultInquiryType="Test Drive Request"
                onClose={() => {}}
                inline
              />
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <BackToTop />
    </div>
  );
};

export default TestDrive;
